module.exports = __webpack_public_path__ + "img/date.ab63c52f.svg";